'use client';

import { useCallback } from 'react';

import { Button } from '@/shared/components/button';
import { ButtonProps } from '@/shared/components/button/ui/types';
import { useUtmHref } from '@/shared/hooks';
import { sendAnalyticsEvent } from '@/shared/lib/analytics/analytics';

type PlatformButtonProps = Omit<ButtonProps, 'href'> & {
  href: string;
  analyticsEvent?: string;
};

export const PlatformButton = ({
  href,
  analyticsEvent,
  onClick,
  ...props
}: PlatformButtonProps) => {
  const hrefWithUtm = useUtmHref(href);

  const handleClick = useCallback(() => {
    if (analyticsEvent) {
      sendAnalyticsEvent(analyticsEvent);
    }
    onClick?.();
  }, [analyticsEvent, onClick]);

  return (
    <Button
      {...props}
      href={hrefWithUtm}
      onClick={analyticsEvent || onClick ? handleClick : undefined}
    />
  );
};
